function ownerDocument(node) {
  return node?.ownerDocument || document;
}
export {
  ownerDocument
};
//# sourceMappingURL=owner.js.map
